/**
 * size-guide-modal-content web component
 * - Wraps the whole size guide modal content.
 * - Tied to the CM/INCH toggle.
 * - Hides/shows the correct size table and updates tab button state.
 */
class SizeGuide extends HTMLElement {
  /** @type {AbortController} */
  #controller = new AbortController();

  connectedCallback() {
    const tableCm = this.querySelector('[data-size-guide-table-unit="cm"]');
    const tableInch = this.querySelector('[data-size-guide-table-unit="inch"]');

    const buttons = Array.from(this.querySelectorAll('[data-size-guide-unit-button]')).filter(
      (b) => b instanceof HTMLButtonElement
    );

    if (buttons.length === 0) return;

    /** @param {string} unit */
    const setActive = (unit) => {
      const normalized = String(unit).toLowerCase();
      const showCm = normalized === 'cm';

      if (tableCm instanceof HTMLElement) tableCm.hidden = !showCm;
      if (tableInch instanceof HTMLElement) tableInch.hidden = showCm;

      buttons.forEach((b) => {
        const isActive = String(b.dataset.unit).toLowerCase() === normalized;
        b.classList.toggle('size-guide-unit-switch__button--active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    const activeButton = buttons.find((b) =>
      b.classList.contains('size-guide-unit-switch__button--active')
    );
    const initialUnit = activeButton?.dataset.unit || this.dataset.activeUnit || 'cm';
    const normalizedInitial = String(initialUnit).toLowerCase() === 'inch' ? 'inch' : 'cm';
    setActive(normalizedInitial);

    buttons.forEach((b) => {
      b.addEventListener(
        'click',
        () => {
          const unit = b.dataset.unit;
          if (!unit) return;
          setActive(unit);
        },
        { signal: this.#controller.signal }
      );
    });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}
